import LabradorAffiliateGallery from '@/base/components/content/AffiliateGallery';

export const standalone = () => null;

export default LabradorAffiliateGallery;
